import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView, LocationFilterState, LocationFacetsData } from 'model/state';
import { Dispatch } from 'redux';
import { LocationView } from 'components';
import { fetchLocations, setSelectAll, setSelectRow, clearMessage, fetchCountryList, fetchRegionList, fetchTimezoneList, addToParent, openConfirmationDialog,
  removeLocations, updateLocationSearch, updateLocationFilters, setCurrentLocation, setLocationSystemModeBulk, incrementLocationPage, reinitLocationPageCount,
  fetchLocationFacets, setShowLocationFilters, removeSingleSelectLocation, setSingleSelectLocation } from 'actions';
import { Location, LocationType, LocationFilters, User, SystemMode, LocationFacet } from 'model';
import {
  selectLocationList, selectUserId, selectIsSelectedAll, selectIsSelectedAny, selectSelectedNumber,
  selectHasErrorMessage, selectIsSubmitting, selectParent, selectLocationSearch, selectLocationFilterData,
  selectLocationFilters, selectSelectedLocations, selectLoggedUser, selectAreAllFullAccessLocations,
  selectShowLocationFilters, selectSingleSelectLocation, selectIsApiCacheDisabled
} from 'selectors';
import { selectIsSubmittingThresholds, selectIsSubmittingAlertSettings } from 'selectors/Settings';

export type FetchLocationsFn = (userId: string, page: number, parentId: string | undefined, search: string, filters: LocationFilters, sort: string[], cached?: boolean) => void;

type SelectedValues = {
  locationList: ListView<Location>,
  userId?: string | null,
  isSelectedAll: boolean,
  isSelectedAny: boolean,
  selectedNumber: number,
  hasError: boolean,
  isSubmitting: boolean,
  isSubmittingThresholdSettings: boolean,
  parent: Location | null,
  search: string,
  selectedLocations: Location[],
  filterData: LocationFacetsData,
  filters: LocationFilterState,
  isSubmittingAlertSettings: boolean,
  loggedUser?: User,
  areAllSelectedFullAccessLocations: boolean,
  showFilters: boolean,
  singleSelectLocation: Location | null,
  apiCacheDisabled?: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  locationList: selectLocationList(),
  userId: selectUserId(),
  isSelectedAll: selectIsSelectedAll(),
  isSelectedAny: selectIsSelectedAny(),
  selectedNumber: selectSelectedNumber(),
  hasError: selectHasErrorMessage(),
  isSubmitting: selectIsSubmitting(),
  isSubmittingThresholdSettings: selectIsSubmittingThresholds(),
  parent: selectParent(),
  search: selectLocationSearch(),
  selectedLocations: selectSelectedLocations(),
  filterData: selectLocationFilterData(),
  filters: selectLocationFilters(),
  isSubmittingAlertSettings: selectIsSubmittingAlertSettings(),
  loggedUser: selectLoggedUser(),
  areAllSelectedFullAccessLocations: selectAreAllFullAccessLocations(),
  showFilters: selectShowLocationFilters(),
  singleSelectLocation: selectSingleSelectLocation(),
  apiCacheDisabled: selectIsApiCacheDisabled(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchLocations: (userId: string, page: number, parentId: string | undefined, search: string, filters: LocationFilters, sort: string[], cached?: boolean) => dispatch(fetchLocations(userId, page, parentId, search, filters, sort, cached)),
  setSelectAll: (selectAll: boolean) => dispatch(setSelectAll(selectAll)),
  setSelectRow: (selectAll: boolean, locationId: string) => dispatch(setSelectRow(selectAll, locationId)),
  clearMessage: () => dispatch(clearMessage()),
  fetchCountryList: () => dispatch(fetchCountryList()),
  cleanRegionList: () => dispatch(fetchRegionList(null)),
  cleanTimezoneList: () => dispatch(fetchTimezoneList(null, null)),
  addToParent: (parentId: string, parentType: LocationType) => dispatch(addToParent(parentId, parentType)),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  removeLocations: () => dispatch(removeLocations()),
  updateSearch: (search: string) => dispatch(updateLocationSearch(search)),
  updateLocationFilters: (filters: LocationFilters) => dispatch(updateLocationFilters(filters)),
  setCurrentLocation: (location: Location | null) => dispatch(setCurrentLocation(location)),
  setLocationSystemModeBulk: (systemModeTarget: SystemMode, revertMinutes?: number) => dispatch(setLocationSystemModeBulk(systemModeTarget, revertMinutes)),
  incrementPage: () => dispatch(incrementLocationPage()),
  reinitPageCount: () => dispatch(reinitLocationPageCount()),
  fetchLocationFacets: (facet: LocationFacet) => dispatch(fetchLocationFacets(facet)),
  setShowLocationFilters: (show: boolean) => dispatch(setShowLocationFilters(show)),
  setSingleSelectLocation: (location: Location) => dispatch(setSingleSelectLocation(location)),
  removeSingleSelectLocation: (location: Location) => dispatch(removeSingleSelectLocation(location)),
});


export default connect(mapStateToProps, mapDispatchToProps)(LocationView);
